import * as React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import { withStyles, withWidth } from '@material-ui/core';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import styles from './collapsibleAttributeWrapper.styles';
import { compose } from '../../../utility';
import type { WindowWidth } from '../../../flowTypes';

type PropType = {
  attributeName: string,
  children: React.Element,
  classes: Object,
  width: WindowWidth,
};

const CollapsibleAttributeWrapperC = ({
  attributeName, children, classes, width,
}: PropType) => (
  <ExpansionPanel
    CollapseProps={{ classes: { container: classes.panel } }}
    defaultExpanded={!['xs', 'sm'].includes(width)}
    elevation={0}
    classes={{
      expanded: classes.expansionPanelExpanded,
    }}
  >
    <ExpansionPanelSummary
      classes={{
        root: classes.root, expanded: classes.expanded, content: classes.content, expandIcon: classes.expandIcon,
      }}
      expandIcon={<ExpandMoreIcon />}
    >
      <Typography className={classes.attributeName}>{attributeName}</Typography>
    </ExpansionPanelSummary>
    <ExpansionPanelDetails classes={{ root: classes.expansionPanelDetails }}>
      {children}
    </ExpansionPanelDetails>
  </ExpansionPanel>
);

export default compose(withStyles(styles), withWidth())(CollapsibleAttributeWrapperC);
